<template>
  <el-select
    v-model="value"
    multiple
    placeholder="Weekdays to show"
    @update:modelValue="updated"
  >
    <el-option
      v-for="item in options"
      :key="item.type_id"
      :label="item.label"
      :value="item.type_id"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { Weekday, WeekdayLabels } from '@/api/types'

export default defineComponent({
  name: 'WeekdaysSelect',
  props: {
    modelValue: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    if (!props.modelValue.length) {
      context.emit('update:modelValue', [
        Weekday.Monday,
        Weekday.Sunday,
        Weekday.Tuesday,
        Weekday.Wednesday,
        Weekday.Thursday,
        Weekday.Friday,
        Weekday.Saturday
      ])
    }

    const options = WeekdayLabels
    const updated = (newValue: Array<Weekday>) => {
      context.emit('update:modelValue', newValue)
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { options, updated, value }
  }
})
</script>
